/**
 * A host child seated below an instance for a `parent_id_path=` that enters the instance's content
 * (`RawNode.parentContentTrail`). The instance's graft follows the rest of the trail in its scene
 * and places the child where Godot's lookup finds the node (`packed_scene.cpp:161-163`, `:1985-2005`).
 */
import { hostChildOf } from './liveNode';
import { SCENE_ROOT_PATH } from '../utils/nodePath';
/**
 * `hosted` with its content trail followed through `follow`. The copy keeps the host child it stands
 * for, so the file that seats it removes the heading it came from (`hostChildOf`).
 */
export function followedChild(hosted, follow) {
    if (hosted.parentContentTrail === undefined)
        return { child: hosted, status: 'placed' };
    const walk = follow(hosted.parentContentTrail);
    if (walk.status === 'pending')
        return { child: hosted, status: 'waiting' };
    if (walk.status === 'missing')
        return { child: reanchoredAt(hosted, SCENE_ROOT_PATH), status: 'missing' };
    return { child: reanchoredAt(hosted, walk.path), status: 'placed' };
}
/**
 * `child` re-aimed at the sub-path its `parent_id_path=` finds in the base the root inherits, for a
 * `parent=` walk that found nothing there (packed_scene.cpp:1960-1979). Undefined for a child with
 * no such trail, an instance below the root, or a base that finds nothing. Waiting where a scene
 * the trail enters is not loaded yet.
 */
export function enteredThroughBase(child, { isInheritedRoot, followTrail }) {
    const { parentTrailFallback } = child;
    if (!isInheritedRoot || parentTrailFallback?.path !== SCENE_ROOT_PATH)
        return undefined;
    const walk = parentTrailFallback.contentTrail && followTrail(parentTrailFallback.contentTrail);
    if (walk?.status === 'pending')
        return { child, status: 'waiting' };
    return walk?.status === 'found' ? { child: reanchoredAt(child, walk.path), status: 'placed' } : undefined;
}
/** `child` seated at `path` below the instance: it keeps its host child, and sheds both trails. */
function reanchoredAt(child, path) {
    const { parentContentTrail: _followed, parentTrailFallback: _spent, ...rest } = child;
    const reanchored = { ...rest, reanchoredFrom: hostChildOf(child) };
    return path === SCENE_ROOT_PATH ? reanchored : { ...reanchored, instanceSubPath: path };
}
//# sourceMappingURL=parentContentTrail.js.map